(function () {
    // save the section id from the script tag and find the section
    const scriptEl = document.currentScript || document.querySelector("script[src*='main-product-restore.js'][data-id]");
    const sectionID = scriptEl && scriptEl.dataset.id;
    const section = (sectionID && document.getElementById(sectionID))
        || document.querySelector("section.productV1--quiz")
        || document.querySelector("section.productV1");

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    // note, the selling plan toggle swaps between separate products, so this is reassigned when the toggle changes
    let product = JSON.parse(section.querySelector(".productV1JSON").textContent);

    // keep the base product so display can fall back to it when a toggle has no product (e.g. a bundle with no base subscription product)
    const baseProduct = product;

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV1VariantJSON").textContent);
    let quantity = 1;
    let lastSkioVariantId = null;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    // collection titles for the klaviyo Viewed Product event, the product JSON drop does not include collections
    const productCollections = JSON.parse(section.querySelector(".productV1CollectionsJSON").textContent);

    // If the section has an announcement text override, store it (the element is only rendered when a block sets one).
    let announcementOverride = false;
    const announcementOverrideJSON = section.querySelector(".productV1AnnouncementOverride");
    if (announcementOverrideJSON) {
        announcementOverride = JSON.parse(announcementOverrideJSON.textContent);
    }

    /************
     Product Swiper
     ************/

    const isQuiz = section.classList.contains("productV1--quiz");
    const mainSwiperEl = section.querySelector(".productV1VisualSwiper");
    const thumbsEl = section.querySelector(".productV1ThumbsSwiper");
    let productSwiper = {slideTo: function () {}};

    if (typeof Swiper !== "undefined" && mainSwiperEl) {
        if (isQuiz) {
            productSwiper = initQuizGallery(section, mainSwiperEl);
        } else {
            const thumbsSwiper = thumbsEl ? new Swiper(thumbsEl, {
                slidesPerView: 5,
                spaceBetween: 10,
                watchSlidesProgress: true,
            }) : null;

            productSwiper = new Swiper(mainSwiperEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: !thumbsSwiper,
                navigation: {
                    nextEl: section.querySelector(".productV1VisualControlsBtn.next"),
                    prevEl: section.querySelector(".productV1VisualControlsBtn.prev"),
                },
                pagination: thumbsSwiper ? undefined : {
                    el: section.querySelector(".productV1VisualControlsPag"),
                    clickable: true,
                },
                thumbs: thumbsSwiper ? {swiper: thumbsSwiper} : undefined,
                autoHeight: !thumbsSwiper,
                on: {
                    slideChange: function () {
                        section.querySelectorAll(".productV1VisualSwiperSlide video").forEach(function (element) {
                            element.pause();
                        });
                    }
                }
            });
        }
    }

    function initQuizGallery(root, viewport) {
        const thumbsViewport = root.querySelector(".productV1ThumbsSwiper");
        const thumbs = thumbsViewport ? Array.from(thumbsViewport.querySelectorAll(".productV1ThumbsSlide")) : [];

        function syncThumbs(activeIndex) {
            thumbs.forEach(function (thumb, thumbIndex) {
                thumb.classList.toggle("is-active", thumbIndex === activeIndex);
            });
            if (thumbsViewport && thumbs[activeIndex]) {
                const rootBox = thumbsViewport.getBoundingClientRect();
                const thumbBox = thumbs[activeIndex].getBoundingClientRect();
                thumbsViewport.scrollLeft += thumbBox.left - rootBox.left - 8;
            }
        }

        const swiper = new Swiper(viewport, {
            slidesPerView: 1,
            spaceBetween: 0,
            rewind: true,
            speed: 400,
            observer: true,
            observeParents: true,
            grabCursor: true,
            simulateTouch: true,
            allowTouchMove: true,
            threshold: 8,
            navigation: {
                nextEl: root.querySelector(".productV1ThumbsBtn.next"),
                prevEl: root.querySelector(".productV1ThumbsBtn.prev"),
            },
            on: {
                slideChange: function () {
                    syncThumbs(this.realIndex);
                    root.querySelectorAll(".productV1VisualSwiperSlide video").forEach(function (element) {
                        element.pause();
                    });
                }
            }
        });

        thumbs.forEach(function (thumb, thumbIndex) {
            thumb.addEventListener("click", function (event) {
                event.preventDefault();
                swiper.slideTo(thumbIndex);
            });
        });

        syncThumbs(0);
        return swiper;
    }

    // play video on slide play click
    section.querySelectorAll(".productV1VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV1VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV1VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        if (element.closest(".productV1SubscribeDetails")) {
            return;
        }
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    async function updateProduct() {

        // find active variant
        activeVariant = await getActiveVariant();

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productV1ATC").disabled = true;
            section.querySelector(".productV1ATCText").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (!isQuiz && activeVariant.featured_image) {
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV1ATC").disabled = false;
            // restore the merchant's add to cart text from the setting so the richtext markup (e.g. strikethrough) survives
            section.querySelector(".productV1ATCText").innerHTML = section.querySelector(".productV1ATC").dataset.addToCartText;
        } else {
            section.querySelector(".productV1ATC").disabled = true;
            section.querySelector(".productV1ATCText").textContent = "Sold Out";
        }

        syncSticky();

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);

        const skioVariant = getSkioSubProductVariant();
        if (skioVariant && skioVariant.id !== lastSkioVariantId) {
            lastSkioVariantId = skioVariant.id;
            document.dispatchEvent(new CustomEvent("variantChanged", {detail: {variantId: skioVariant.id}}));
        }
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    function getSelectedSellingPlanId() {
        const frequencySelect = section.querySelector(".productV1SellingFreqSelect");
        if (frequencySelect && frequencySelect.value) {
            return frequencySelect.value;
        }

        return section.querySelector(".productV1SellingLabelInput:checked")?.dataset.plan;
    }

    let sellingPlans = [];
    try {
        sellingPlans = JSON.parse(section.querySelector(".productV1SellingPlansJSON").textContent);
    } catch (error) {
        sellingPlans = [];
    }

    function getSubscriptionPrice(variant, planId) {
        const plan = sellingPlans.find(function (item) {
            return String(item.id) === String(planId);
        });
        return plan ? plan.price : variant.price;
    }

    function syncSticky() {
        const stickyATC = section.querySelector(".productV1StickyATC");
        const stickyValue = section.querySelector(".productV1StickyATCValue");
        if (!stickyATC || !stickyValue || !activeVariant) {
            return;
        }

        stickyATC.classList.remove("sub");
        stickyATC.dataset.variantId = activeVariant.id;
        stickyATC.dataset.sellingPlan = "";

        if (!activeVariant.available) {
            stickyValue.textContent = "";
            return;
        }

        if (isSubscription()) {
            const planId = getSelectedSellingPlanId();
            stickyATC.classList.add("sub");
            stickyATC.dataset.sellingPlan = planId || "";
            stickyValue.textContent = price(getSubscriptionPrice(activeVariant, planId), true).toString();
            return;
        }

        stickyValue.textContent = price(activeVariant.price, true).toString();
    }

    function applyPlanQuiz(plan, frequency) {
        if (!plan && !frequency) {
            return;
        }

        if (plan) {
            const input = section.querySelector(`.productV1SellingLabelInput[value="${plan}"]`);
            if (input && !input.checked) {
                input.checked = true;
            }
        }

        if (frequency) {
            const option = section.querySelector(`.productV1SellingFreqSelect option[data-frequency="${frequency}"]`);
            const select = section.querySelector(".productV1SellingFreqSelect");
            const subInput = section.querySelector('.productV1SellingLabelInput[value="sub"]');
            if (option && select) {
                select.value = option.value;
                if (subInput) {
                    subInput.dataset.plan = option.value;
                    subInput.checked = true;
                }
            }
        }

        updateProduct();
    }

    const otpFirst = section.classList.contains("productV1--otp-first");

    document.addEventListener("cheers:pdp-plan-quiz", function (event) {
        if (otpFirst) {
            return;
        }
        applyPlanQuiz(event.detail?.plan, event.detail?.frequency);
    });

    if (!otpFirst) {
        try {
            const storedQuiz = JSON.parse(sessionStorage.getItem("cheers:pdp-plan-quiz"));
            applyPlanQuiz(storedQuiz?.plan, storedQuiz?.frequency);
        } catch (error) {}
    }

    section.querySelector(".productV1SellingFreqSelect")?.addEventListener("change", function () {
        const subInput = section.querySelector('.productV1SellingLabelInput[value="sub"]');
        if (subInput) {
            subInput.dataset.plan = this.value;
            subInput.checked = true;
        }
        updateProduct();
    });

    section.querySelectorAll(".productV1AccordionItem").forEach(function (item) {
        const summary = item.querySelector(".productV1AccordionItemTop");
        const content = item.querySelector(".productV1AccordionItemBottom");
        if (!summary || !content) {
            return;
        }

        let animation = null;
        let isClosing = false;
        let isExpanding = false;

        function onAnimationFinish(open) {
            item.open = open;
            animation = null;
            isClosing = false;
            isExpanding = false;
            item.style.height = "";
            item.style.overflow = "";
        }

        function shrink() {
            isClosing = true;
            const startHeight = item.offsetHeight + "px";
            const endHeight = summary.offsetHeight + "px";
            if (animation) {
                animation.cancel();
            }
            item.style.overflow = "hidden";
            animation = item.animate({
                height: [startHeight, endHeight]
            }, {
                duration: 320,
                easing: "ease"
            });
            animation.onfinish = function () {
                onAnimationFinish(false);
            };
            animation.oncancel = function () {
                isClosing = false;
            };
        }

        function expand() {
            isExpanding = true;
            const startHeight = item.offsetHeight + "px";
            const endHeight = summary.offsetHeight + content.offsetHeight + "px";
            if (animation) {
                animation.cancel();
            }
            animation = item.animate({
                height: [startHeight, endHeight]
            }, {
                duration: 320,
                easing: "ease"
            });
            animation.onfinish = function () {
                onAnimationFinish(true);
            };
            animation.oncancel = function () {
                isExpanding = false;
            };
        }

        function openItem() {
            item.style.height = item.offsetHeight + "px";
            item.style.overflow = "hidden";
            item.open = true;
            window.requestAnimationFrame(expand);
        }

        summary.addEventListener("click", function (event) {
            event.preventDefault();
            section.querySelectorAll(".productV1AccordionItem").forEach(function (other) {
                if (other !== item && other.open) {
                    other.querySelector(".productV1AccordionItemTop")?.dispatchEvent(new CustomEvent("accordion-close"));
                }
            });
            if (isClosing || !item.open) {
                openItem();
            } else if (isExpanding || item.open) {
                shrink();
            }
        });

        summary.addEventListener("accordion-close", function () {
            if (item.open && !isClosing) {
                shrink();
            }
        });
    });

    section.querySelectorAll("[data-scroll-target]").forEach(function (element) {
        element.addEventListener("click", function () {
            const target = document.querySelector("." + this.dataset.scrollTarget);
            if (!target) {
                return;
            }

            const nav = document.querySelector(".navV1Inner");
            const offset = nav ? nav.getBoundingClientRect().height + 24 : 24;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({top: Math.max(0, top), behavior: "smooth"});
        });
    });

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV1QuantityControlsBtn.minus")?.addEventListener("click", async function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV1QuantityControlsValue").textContent = quantity;
        await updateProduct();
    });

    // plus
    section.querySelector(".productV1QuantityControlsBtn.plus")?.addEventListener("click", async function () {
        quantity++;
        section.querySelector(".productV1QuantityControlsValue").textContent = quantity;
        await updateProduct();
    });

    // update product on input change
    section.querySelectorAll(".productV1OptionsItemValuesLabelInput").forEach(function (element) {
        element.addEventListener("change", async function () {
            await updateProduct();
        });
    });

    /**
     * Returns the product for the checked selling plan toggle.
     * OTP uses the page product; Subscribe uses sub_product from data-product.
     * @returns {Object} The active product object
     */
    function getActiveProduct() {
        const sellingInput = section.querySelector(".productV1SellingLabelInput:checked");

        if (!sellingInput) {
            return baseProduct;
        }

        try {
            const toggleProduct = JSON.parse(sellingInput.dataset.product || "null");
            if (!toggleProduct) {
                return baseProduct;
            }
            return toggleProduct;
        } catch (error) {
            return baseProduct;
        }
    }

    /**
     * Checks whether the subscription selling plan toggle is selected.
     * @returns {boolean} True when the checked toggle is the subscription product
     */
    function isSubscription() {
        return section.querySelector(".productV1SellingLabelInput:checked")?.value === "sub";
    }

    /**
     * Fetches the active variant based on the selected options.
     * Subscribe resolves against sub_product; OTP against the page product.
     * If there are more than 250 variants, it makes a request to the server to fetch the active variant since Shopify's storefront API has a limit of 250 variants per product.
     * @returns {Promise<Object>} The active variant object
     */
    async function getActiveVariant() {
        // resolve the product the selling plan toggle currently points at
        product = getActiveProduct();

        // Fetch variant when exceeding Shopify's 250 variant limit
        if (product.variants.length >= 250) {
            const optionIDs = [];
            section.querySelectorAll(".productV1OptionsItemValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.id);
            });
            const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());
            return response.active_variant;
        }

        // If there's only one variant, return it immediately
        if (product.variants.length === 1) {
            return product.variants[0];
        }

        // Gather selected values
        const options = [];
        section.querySelectorAll('.productV1OptionsItem').forEach(group => {
            options.push(group.querySelector('input:checked').value);
        });

        // Find matching variant and return it
        return product.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
    }

    /**
     * Resolves sub_product's own variant matching the currently selected options,
     * independent of which selling-plan toggle is checked -- see main-product-v1.js.
     * @returns {Object|null} The matching sub_product variant, or null if unavailable
     */
    function getSkioSubProductVariant() {
        const subInput = section.querySelector('.productV1SellingLabelInput[value="sub"]');
        let subProduct;
        try {
            subProduct = JSON.parse(subInput?.dataset.product || "null");
        } catch (error) {
            return null;
        }
        if (!subProduct || !subProduct.variants) {
            return null;
        }
        if (subProduct.variants.length === 1) {
            return subProduct.variants[0];
        }

        const options = [];
        section.querySelectorAll('.productV1OptionsItem').forEach(group => {
            options.push(group.querySelector('input:checked').value);
        });

        return subProduct.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        ) || subProduct.variants[0];
    }

    /**************
     Product ATC
     ***************/

    async function addToCart(options) {
        if (options && typeof options.preventDefault === "function") {
            options.preventDefault();
        }

        const forceOtp = Boolean(options) && options.forceOtp === true;
        const atc = section.querySelector(".productV1ATC");
        const stickyATC = section.querySelector(".productV1StickyATC");
        atc?.classList.add("loading");
        stickyATC?.classList.add("loading");

        let added = false;
        try {
            if (!forceOtp) {
                syncSticky();
            }

            await updateProduct();

            if (!activeVariant) {
                throw new Error("No active variant");
            }

            const item = {quantity: quantity, id: activeVariant.id};
            const planId = parseInt(getSelectedSellingPlanId(), 10);
            const otpVariantId = parseInt(section.dataset.otpVariantId, 10);
            const subVariantId = parseInt(section.dataset.subVariantId, 10);
            const sellingInput = section.querySelector(".productV1SellingLabelInput:checked");
            const explicitSubVariantId = parseInt(sellingInput?.dataset.variantId, 10);
            const wantsOtp = forceOtp || !isSubscription();

            if (wantsOtp) {
                // Copy Restore cannot be sold one-time (requires_selling_plan).
                // Add the OTP Restore variant instead, with no selling plan.
                if (otpVariantId && otpVariantId !== item.id) {
                    item.id = otpVariantId;
                }
            } else {
                if (!planId) {
                    throw new Error("No selling plan selected");
                }
                item.selling_plan = planId;
                if (explicitSubVariantId) {
                    item.id = explicitSubVariantId;
                } else if (subVariantId) {
                    item.id = subVariantId;
                }
            }

            const tmpl = section.dataset.template;
            if (tmpl) {
                item.properties = Object.assign({}, item.properties, {_template: tmpl});
            }

            const result = await fetch("/cart/add.js", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                credentials: "same-origin",
                cache: "no-store",
                body: JSON.stringify({items: [item]})
            }).then(function (response) {
                return response.json().then(function (data) {
                    return {ok: response.ok, data: data};
                });
            });

            if (!result.ok || result.data.status) {
                throw new Error(result.data.description || result.data.message || "Add to cart failed");
            }

            added = true;
        } catch (error) {
            console.error("Add to cart failed", error);
        } finally {
            atc?.classList.remove("loading");
            stickyATC?.classList.remove("loading");
        }

        if (added) {
            try {
                await openCart();
            } catch (error) {
                console.error("Open cart failed", error);
            }
        }
    }

    section.querySelector(".productV1ATC")?.addEventListener("click", addToCart);
    section.querySelector(".productV1StickyATC")?.addEventListener("click", addToCart);

    section.querySelector(".productV1SellingOtp")?.addEventListener("click", async function (event) {
        event.preventDefault();
        await addToCart({ forceOtp: true });
    });

    /**************
     Amazon Links
     ***************/

    // external "Shop on Amazon" links: fire the custom Amazon Click event plus an Add to Cart optimization signal
    section.querySelectorAll(".productV1LinksItem").forEach(function (element) {
        element.addEventListener("click", function () {
            // send an Add to Cart signal (variant id, matching their other pixels) so Amazon clicks optimize like a conversion
            const price = activeVariant ? activeVariant.price * quantity : 0;
            const productID = product.id;

            // gtag
            try {
                gtag("event", "click", {
                    "event_category": "website-amz-click",
                    "event_label": "prodpage-amz-click"
                });
                gtag("event", "add_to_cart", {
                    currency: Shopify.currency,
                    value: price,
                    items: [{item_id: productID}]
                });
            } catch (e) {
                console.error(`Failed to fire gtag for amazon click ${e}`)
            }

            // klaviyo
            try {
                klaviyo.push(["track", "Amazon Click"]);
                klaviyo.push(["track", "Added to Cart", {
                    ProductID: productID,
                    Value: price,
                    Currency: Shopify.currency
                }]);
            } catch (e) {
                console.error(`Failed to fire klaviyo for amazon click ${e}`)
            }

            // PostHog custom event
            try {
                posthog.capture("Amazon Click");
                posthog.capture("Add To Cart", {
                    product_id: productID,
                    value: price,
                    currency: Shopify.currency
                });
            } catch (e) {
                console.error(`Failed to fire posthog for amazon click ${e}`)
            }

            // facebook events
            try {
                fbq("track", "amz-click");
                fbq("track", "AddToCart", {
                    content_ids: [productID],
                    content_type: "product",
                    value: price,
                    currency: Shopify.currency
                });
            } catch (e) {
                console.error(`Failed to fire facebook for amazon click ${e}`)
            }

            // Intelligems: secondary goal for the Restore ABCD test
            try {
                window.igEvents = window.igEvents || [];
                window.igEvents.push({ event: "Amazon Click" });
            } catch (e) {
                console.error(`Failed to fire intelligems for amazon click ${e}`)
            }

        });
    });


    // Scroll to reviews
    section.querySelectorAll('.scrollToReviews')?.forEach((element) => {
        element.addEventListener("click", function () {

            const reviewsTarget = document.querySelector(".reviewsTarget");
            if (!reviewsTarget) {
                return;
            }

            // smooth scroll the reviews into view, offset by 80px for the fixed header
            const top = reviewsTarget.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({top: top, behavior: "smooth"});
        })
    })

    /*************************
     Announcement Override
     *************************/
    if (announcementOverride) {
        document.querySelector("#announcementText").innerHTML = announcementOverride.override_text;
    }

    /*************************
     Klaviyo Viewed Product
     *************************/

    // the klaviyo library is held until marketing consent is granted, so the view can only be tracked once it exists
    (async () => {
        await doesHaveMarketingConsent();

        // poll for the async library, the push would throw if it fired before klaviyo.js finished loading
        while (typeof klaviyo === "undefined") {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        // build from baseProduct, the selling plan toggle can reassign product while we wait on consent
        try {
            klaviyo.push(["track", "Viewed Product", {
                ImageURL: `https:${baseProduct.featured_image}`,
                Price: price(baseProduct.price),
                Name: baseProduct.title,
                ProductID: baseProduct.id,
                Categories: productCollections,
                Value: (baseProduct.price / 100).toFixed(2),
                Brand: baseProduct.vendor,
                URL: `${window.location.origin}/products/${baseProduct.handle}`,
                CompareAtPrice: price(baseProduct.compare_at_price || 0)
            }]);
        } catch (e) {
            console.error(`Failed to fire klaviyo for viewed product ${e}`)
        }
    })();

}());
